"use strict";var VNode = require("./VNode");
var inherit = require("raptor-util/inherit");

function VComment(value, ownerComponent) {
  this.bV_(-1 /* no children */, ownerComponent);
  this.bW_ = value;
}

VComment.prototype = {
  bX_: 8,

  bo_: function (host) {
    var nodeValue = this.bW_;
    return (host.ownerDocument || host).createComment(nodeValue);
  },

  bP_: function () {
    return new VComment(this.bW_);
  }
};

inherit(VComment, VNode);

module.exports = VComment;